import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import {
    FirstTaskRewardService,
    type FirstTaskRewardService as FirstTaskRewardServiceType,
} from '../../first-task-reward/first-task-reward-service';
import type { DesignFtoReportOnboardingService } from '../design-fto-report-onboarding-service';

/** 将 Design FTO 报告可阅读事件转交给统一首次任务奖励服务。 */
@injectable()
export class DesignFtoReportOnboardingServiceImpl implements DesignFtoReportOnboardingService {
    private _isInitialized = false;

    constructor(
        @inject(FirstTaskRewardService)
        private readonly _rewardService: FirstTaskRewardServiceType,
    ) {}

    async initialize(): Promise<void> {
        this._isInitialized = true;
    }

    notifyReportAvailable(taskId: string): void {
        if (!this._isInitialized || !taskId) return;
        this._start(taskId);
    }

    debugStart(taskId: string): void {
        if (!import.meta.env.DEV || !taskId) return;
        this._isInitialized = true;
        this._start(taskId);
    }

    destroy(): void {
        this._isInitialized = false;
        this._rewardService.destroyReport();
    }

    private _start(taskId: string): void {
        this._rewardService.startReport({
            taskId,
            agentType: 'DESIGN_FTO_SEARCH',
            reportSelector: '[data-testid="design-fto-report-content"]',
            shareSelector: '[data-testid="design-fto-report-share"]',
            exportSelector: '[data-testid="design-fto-report-export"]',
        });
    }
}
